module.exports = __webpack_public_path__ + "html/video-slider_986390f62bb608d1dec6acf0c3fd8ebd.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/video-slider.html
// module id = isjR
// module chunks = 26